angular.module('elfium').directive('navbar', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'navbarController',
        templateUrl: elfiumUrlService.getTemplateUrl('navbar')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.ts